exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sebm-google-map-container {\r\n  height: 470px;\r\n}\r\n\r\nh1 {\r\n  vertical-align: top;\r\n}\r\n\r\n.form-left {\r\n  max-width: 408px;\r\n  width: 100%;\r\n  float: left;\r\n}\r\n\r\n.form-right {\r\n  float: left;\r\n  max-width: 300px;\r\n  width: 100%;\r\n  margin-left: 75px;\r\n}\r\n\r\n.title {\r\n    font-family: \"Myriad Pro\";\r\n    margin-top: 10px;\r\n    font-size: 36px;\r\n}\r\n\r\n.container {\r\n  text-align: center;\r\n  display: block;\r\n  max-width: 830px;\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.background-params {\r\n  width: auto;\r\n  background-color: white;\r\n  margin-bottom: 20px;\r\n  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.contact-info{\r\n    color: #7a7a7a;\r\n    font-size: 14px;\r\n    font-family: 'Open Sans', sans-serif;\r\n    line-height: 16px;\r\n    letter-spacing: -0.025em;\r\n}\r\n\r\n.email {\r\n  font-weight: bold;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contact/contact.component.css
// module id = 752
// module chunks = 1